import React from 'react';
import PropTypes from 'prop-types';
import Edit from './rowActions/Edit';
import { Box } from '@mui/material';
import { DownloadCSV } from './rowActions/DownloadCSV';

const RowActions = ({ rowData, setDetailCallbackComponent }) => <Box>
  <Edit rowData = {rowData} setDetailCallbackComponent = {setDetailCallbackComponent}/>
  <DownloadCSV rowData={rowData} />
</Box>;


RowActions.propTypes = {
  row: PropTypes.object.isRequired,
  setDetailCallbackComponent: PropTypes.func
};


export default RowActions;
